export default {
  dataLead: {
    leadId: '',
    customerName: '',
    merchantName: '',
    email: '',
    mobile: '',
    address: '',
    cityCode: '',
    city: '',
    districtCode: '',
    district: '',
    note: ''
  }
}
